import React from 'react' 
import Header from './Header'
import VideoList from './VideoList'
import Footer from './Footer'
 
function App() {
 
  return (
    <div id="app">
      <Header />
      <VideoList />
      <Footer />
    </div>
  )
}
export default App;
